import React from 'react';
import styled, { css } from 'styled-components';
import {
  brandFonts,
  fontSize,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
  visuallyHidden,
} from '../styles';
import { Container, Slider, Svg } from './ui';
import quoteIcon from '../images/quote.inline.svg';

const StyledTestimonials = styled.section`
  ${sectionMargins()};
`;

const StyledWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 30px;

  ${minBreakpointQuery.medium`
    grid-template-columns: 60px 1fr 60px;
    column-gap: 20px;
  `}

  ${minBreakpointQuery.large`
    column-gap: 40px;
  `}
`;

const StyledQuoteIcon = styled(Svg)`
  width: 48px;
  height: 38px;
  margin: 0 auto;

  ${minBreakpointQuery.large`
    width: 60px;
    height: 56px;
  `}

  ${({ alt }) => {
    if (alt) {
      return css`
        transform: rotate(180deg);

        ${maxBreakpointQuery.medium`
          grid-row-start: 1;
          grid-column-start: 2;
        `}
      `;
    }
  }};
`;

const StyledSliderWrapper = styled.div`
  overflow: hidden;

  ${maxBreakpointQuery.medium`
    grid-column: 1 / 3;
  `}
`;

const StyledSlider = styled(Slider)``;

const StyledTestimonial = styled.blockquote`
  margin: 0;
`;

const StyledText = styled.p`
  ${fontSize(25)};
  font-family: ${brandFonts.secondary};
  text-align: center;

  ${minBreakpointQuery.mlarge`
    ${fontSize(28)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(30)};
  `}

  ${minBreakpointQuery.xlarge`
    ${fontSize(35)};
  `}
`;

const StyledLogo = styled.img`
  max-width: 350px;
  margin: 0 auto;

  ${maxBreakpointQuery.medium`
    ${visuallyHidden()};
  `}

  ${minBreakpointQuery.medium`
    margin-top: 50px;
  `}

  ${minBreakpointQuery.mlarge`
     margin-top: 60px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 70px;
  `}

  ${minBreakpointQuery.xlarge`
    margin-top: 80px;
  `}
`;

const Testimonials = ({ items }) => {
  const sliderOptions = {
    arrows: false,
    autoplay: true,
    dots: true,
    pauseOnHover: true,
    adaptiveHeight: true,
  };

  return (
    <StyledTestimonials>
      <Container narrow={true}>
        <StyledWrapper>
          <StyledQuoteIcon image={quoteIcon} />
          <StyledSliderWrapper>
            <StyledSlider numSlides={items.length} {...sliderOptions}>
              {items.map(({ text, logo }, i) => (
                <StyledTestimonial key={i}>
                  <StyledText>{text}</StyledText>
                  {logo && <StyledLogo src={logo.url} alt={logo.alt} />}
                </StyledTestimonial>
              ))}
            </StyledSlider>
          </StyledSliderWrapper>
          <StyledQuoteIcon image={quoteIcon} alt={true} />
        </StyledWrapper>
      </Container>
    </StyledTestimonials>
  );
};

export default Testimonials;
